var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.registerType)?_c('div',[_vm._v("\n    "+_vm._s(_vm.$t("firstPasswordRegistration.rules.description"))+"\n  ")]):_vm._e(),_vm._l((_vm.rules),function(rule,key){return _c('div',{key:key,staticClass:"d-flex align-center"},[(!_vm.registerType)?_c('v-icon',{staticClass:"pr-1",attrs:{"color":rule.error ? 'red lighten-1' : 'green'}},[_vm._v("\n      "+_vm._s(rule.error ? "mdi-close" : "mdi-check")+"\n    ")]):_vm._e(),_c('span',{class:[
        _vm.registerType ? 'caption' : '',
        rule.error ?
          'red--text text--lighten-1' :
          'green--text'
      ]},[_vm._v("\n      "+_vm._s(_vm.$t(rule.message))+"\n    ")])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }